import React from 'react'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import * as _ from 'recompose'

import PaymentCard from './Card'
import RadioSvg from '../../../components/Icons/RadioSvg'
import { setPaymentData } from '../../../store/reducers/paymentMethods'

//import GiftCard from './GiftCard'

const PaymentMethod = ({
  title,
  name,
  isConfirmed = false,
  withVisual = false,
  cards = [],
  onClick,
  onClickCard,
  onChange,
  selected,
  type
}) => {//console.log('name1',name, cards)
return(
  <div>
  <div className='PaymentMethod' onClick={()=>onClick(cards)}>{/*метод оплаты */}
    <div className='PaymentMethod__header'>
      <div className='PaymentMethod__radio'>
        <RadioSvg checked={selected} />
      </div>
      <div className='PaymentMethod__title'>
        {type === "giftcards" ? "Оплата подарочной картой" : title}
        {(isConfirmed && !withVisual) && <span className='PaymentMethod__activated'><FormattedMessage id='bidPayment.activated' /></span>}
      </div>
    </div>
    </div>
    {(isConfirmed && withVisual) && (
      <div className='PaymentMethod__content'>
        <div className='PaymentCards'>{/*платежная карта - смена карты и плат системы */}
          {cards.map(paymentId => (
            <div key={paymentId} onClick={onClickCard}><PaymentCard  paymentId={paymentId} onChange={onChange} currentMethod={name}/></div>
          ))}
          <div className='PaymentCards__item'>
          <div onClick={onClickCard}><PaymentCard empty onChange={onChange} currentMethod={name} /> </div>
          </div>
        </div>
      </div>
    )}
  </div>
)}

const mapState = (state, { name, type }) => {
  delete state.paymentMethods.methods["rbk_money"]
  return({
  ...state.paymentMethods.methods[name],
  type: type,
  selected: state.paymentMethods.data.paymentMethod === name
})}

const mapDispatch = (dispatch, props) => ({
  onClick: (cards) => {//нажатие на плат систему
    dispatch(setPaymentData('paymentMethod', props.name))//меняем плат систему
    dispatch(setPaymentData('userPaymentId', (cards && cards.length > 0) ? cards[0] : null))//меняем карту в соответствии 
    props.onChange('paymentMethod', props.name)
    props.onChange('userPaymentId', (cards && cards.length > 0) ? cards[0] : null)
  },
  onClickCard: () => {//нажатие на карту
    dispatch(setPaymentData('paymentMethod', props.name))//меняем плат систему, карта меняется в Card.js по onChange
    props.onChange('paymentMethod', props.name)
  },
})

export default _.compose(
  connect(mapState, mapDispatch),
  _.withHandlers({
    initCard: (props) => async e => {//при открытии компонента, нужно выбрать карту (в соответствии с уже выбранной плат системой)
      e && e.preventDefault()
      props.onClick(props.cards)
    }
  }),
  _.lifecycle({
    componentDidMount () {
      //this.props.onClick()
      this.props.initCard()
    }
  })
)(PaymentMethod)




// WEBPACK FOOTER //
// ./src/components/Lot/PaymentSelect/Method.js